<template>
  <div data-v-f531b812="" id="app" class="app app-ti_green">
    <div data-v-8a75a126="" data-v-f531b812="" class="header">
      <div data-v-8a75a126="" class="header__top-wrapper">
        <div data-v-8a75a126="" class="van-nav-bar van-nav-bar--fixed fixed-top rounded-corners nav-header">
          <div class="van-nav-bar__content">
            <div class="van-nav-bar__left" @click="$router.back()">
              <i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
            </div>
            <div class="van-nav-bar__title van-ellipsis">添加虚拟币地址</div>
            <div class="van-nav-bar__right" @click="$parent.openKefu">
              <div class="header-style-icon"><img src="/static/image/kefuIcon.9bf50982.png" /></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div data-v-093ec75a="" data-v-f531b812="" class="card-add-container green-card-add-container">
      <div data-v-093ec75a="" class="card-add-container__input">
   
        <p data-v-093ec75a="">虚拟币种类:</p>
        <div data-v-093ec75a="" class="Virtual-name">
          <div data-v-093ec75a="" class="green-bg virtual-type" style="text-align: left">
            <img data-v-093ec75a="" src="/static/image/uacPlmHNWCaAGIUQAAAQIj_X9wY600.png" />
            <p data-v-093ec75a="">USDT</p>
          </div>
        </div>
        <p data-v-093ec75a="">虚拟币协议:</p>
        <div data-v-093ec75a="" style="display: flex; flex-wrap: wrap">
          <div data-v-093ec75a="" @click="changXie('TRC20')" :class="usdtInfo.bank_owner == 'TRC20' ? ' green-bg virtual-type' :'green-border virtual-type' "><p data-v-093ec75a="">TRC20</p></div>
          <div data-v-093ec75a="" @click="changXie('ERC20')" :class="usdtInfo.bank_owner == 'ERC20' ? ' green-bg virtual-type' :'green-border virtual-type' "><p data-v-093ec75a="">ERC20</p></div>
        </div>
        <p data-v-093ec75a="">虚拟币地址:</p>
        <div data-v-093ec75a="" class="van-cell van-field">
          <div class="van-cell__value van-cell__value--alone van-field__value">
            <div class="van-field__body"><input type="text" autocomplete="new-accounts" v-model="usdtInfo.bank_no" oninput="value=value.replace(/[\W]/g,'')"  placeholder="请输入虚拟币地址" class="van-field__control" /></div>
          </div>
        </div>
           <p data-v-093ec75a="">支付密码:</p>
        <div data-v-093ec75a="" class="van-cell van-field">
          <div class="van-cell__value van-cell__value--alone van-field__value">
            <div class="van-field__body"><input type="password" autocomplete="new-password" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')"
 v-model="usdtInfo.pay_pass" placeholder="请输入支付密码" class="van-field__control" /></div>
          </div>
        </div>
      </div>
      <div data-v-093ec75a="" class="mid-warn-wrap">请认真校对虚拟币地址和虚拟币协议的一致性，因地址和协议错误产生的损失由您自行承担！</div>
      <div data-v-093ec75a="" class="account-button van-row van-row--flex van-row--justify-center">
        <button data-v-093ec75a="" @click="bindUsdss" type="submit" class="determine-btn van-button van-button--primary van-button--normal van-button--block">
          <div data-v-093ec75a="" class="van-button__content"><span data-v-093ec75a="" class="van-button__text"> 确认 </span></div>
        </button>
      </div>
      <div data-v-093ec75a="" class="account-txt van-row van-row--flex van-row--justify-center"></div>
    </div>
    <div data-v-f531b812="" class="float-divbox"></div>
    <span data-v-7b0f8a3e="" data-v-f531b812="" class="customer-service-container"></span><span data-v-f531b812=""></span>
    <div data-v-55ec3770="" data-v-f531b812="" class="select-service-line-view select-service-line-view">
      <dl data-v-55ec3770="" class="select-service-list"><div data-v-55ec3770="" style="height: 55px"></div></dl>
    </div>
  </div>
</template>
<script>
export default {
  name: 'addUsdtCard',
  data() {
    return {
      usdtInfo: { bank_owner: 'TRC20' },

    };
  },
  created() {
    let that = this;
  },
  methods: {
    changXie(name){
      this.usdtInfo.bank_owner = name;
    },
        bindUsdss() {
      let that = this;
      let usdtInfo = that.usdtInfo;
      usdtInfo.bank = 'USDT';
      if (usdtInfo.bank_no == null || usdtInfo.bank_no == '') {
        that.$parent.showTost(0, '请输入USDT地址');
        return;
      }
      if (!usdtInfo.bank_owner || usdtInfo.bank_owner == null) {
        that.$parent.showTost(0, '请选择钱包协议');
        return;
      }
      if (!usdtInfo.pay_pass) {
        that.$parent.showTost(0, '请输人支付密码');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bindcard', usdtInfo)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, res.message);
            that.$router.back();
          
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
 #form_card .addcard-wrap .mod-forms label{padding-left:30px; background:no-repeat 10px 10px; background-size:22px;}
    #form_card .addcard-wrap .mod-forms li .form-ipt .txt-ipt{width:80%;}
    .select2-container--default .select2-selection--single{border:0 !important;}
    .select2-container--default .select2-selection--single .select2-selection__rendered{line-height: 43px !important;}
    .select2-container--default .select2-selection--single .select2-selection__arrow{top: 10px !important;}
</style>



// WEBPACK FOOTER //
// src/components/addUsdtCard.vue